import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { rssCategoryRoute } from "app/router";
import { trpc } from "lib/trpc";
import { RSSFeed } from "@compass/shared/types";
import { RssFeedCard } from "./RssFeedCard";

interface RssFeedSectionProps {
    feed: RSSFeed;
    searchValue: string;
}

const RssFeedSection = ({ feed, searchValue }: RssFeedSectionProps) => {
    const navigate = useNavigate();

    const { data, isPending: isLoading } = trpc.rss.entriesByFeed.useQuery({
        feedId: feed.id,
        searchTerm: searchValue,
    });

    const [showingAll, setShowingAll] = useState(false);

    const articles = data?.entries ?? [];
    const itemsToShow = showingAll ? articles : articles.slice(0, 4);

    if (articles.length === 0 || isLoading) return null;

    return (
        <section className="mb-6">
            <div className="flex justify-between">
                <h2 className="mb-6 font-sans text-[24px] font-semibold text-[#424242]">
                    {feed.title}
                </h2>
                {articles.length > 4 && (
                    <span
                        className="cursor-pointer font-sans text-[20px] font-normal text-[#37598A] underline hover:underline"
                        onClick={() => {
                            navigate({
                                to: "/rss-feeds/category/$categoryName",
                                params: { categoryName: String(feed.id) },
                            });
                            setTimeout(() => {
                                const el = document.getElementById("scrollable-content");
                                el?.scrollTo({ top: 0, behavior: "smooth" });
                            }, 0);
                        }}
                    >
                        See All
                    </span>
                )}
            </div>

            {isLoading ? (
                <p className="text-sm text-slate-500"></p>
            ) : (
                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                    {itemsToShow.map((article) => (
                        <div key={article.id}>
                            <RssFeedCard
                                articleId={article.id}
                                title={article.title}
                                description={article.excerpt}
                                date={article.publishedAt?.split("T")[0] ?? ""}
                                link={article.url ?? ""}
                                imageUrl={article.imageUrl ?? ""}
                                feedSourceTitle={article.feedSourceTitle}
                            />
                        </div>
                    ))}
                </div>
            )}
        </section>
    );
};

export default RssFeedSection;
